module.exports = __webpack_public_path__ + "img/sm3_maskFIT_xl.51910f65.png";